import { GA4Event } from '@jusbrasil-web/shared-ga4'

import { EVENT } from '../constants'

export interface GA4InputStartEventProps {
  componentClass?: string | null
  componentName?: string | null
  featureClass?: string | null
  featureName?: string | null
  inputMethod: string
}

export class GA4InputStartEvent extends GA4Event {
  ga4_component_class: GA4InputStartEventProps['componentClass']
  ga4_component_name: GA4InputStartEventProps['componentName']
  ga4_feature_class: GA4InputStartEventProps['featureClass']
  ga4_feature_name: GA4InputStartEventProps['featureName']
  ga4_input_method: GA4InputStartEventProps['inputMethod']

  constructor({
    componentClass = null,
    componentName = null,
    featureClass = null,
    featureName = null,
    inputMethod,
  }: GA4InputStartEventProps) {
    super({ event: EVENT.INPUT_START })

    this.ga4_component_class = componentClass
    this.ga4_component_name = componentName
    this.ga4_feature_class = featureClass
    this.ga4_feature_name = featureName
    this.ga4_input_method = inputMethod
  }
}
